export const verHPC9 = "2.24";
